import { notificationActionDispatcher } from 'services/notifications/registry'
import { INotification, INotificationClickOptions, NavigateFn } from 'services/notifications/types'

// Single entrypoint for "what happens when a notification is acted on" — called from the
// cold-start bootstrap, the warm-tab service worker message listener, the in-app push toast,
// and the Notification Center's row click. Keep every one of those call sites thin wrappers
// around this function rather than re-implementing resolution/navigation/mark-seen locally.
export async function handleNotificationClick(
  notification: INotification,
  navigate: NavigateFn,
  options?: INotificationClickOptions
): Promise<void> {
  return notificationActionDispatcher.handle(notification, navigate, options)
}
